// extracted by mini-css-extract-plugin
export default {"container":"NewsComponent_container__20jk7","readMore":"NewsComponent_readMore__WwNQk","description":"NewsComponent_description__IbeI1"};